
angular.module('qkr.merchant.reports').controller('ByorSelectColumnController', ByorSelectColumnController);

function ByorSelectColumnController($uibModalInstance, availableColumns, columnsToAdd) {
    const vm = this;

    class SelectableColumn {
        constructor(name, label) {
            this.name = name;
            this.label = label;
            this.selected = false;
        }
    }

    vm.availableColumns = availableColumns.map(c => new SelectableColumn(c.name, c.label, false));
    vm.columnsToAdd = columnsToAdd;

    vm.cancel = function() {
        $uibModalInstance.close('cancel');
    };

    vm.ok = function() {
        vm.availableColumns.forEach(ac => {
            if (ac.selected) {
                columnsToAdd.push({name: ac.name, label: ac.label});
            }
        });
        $uibModalInstance.close('ok');
    };
}




// WEBPACK FOOTER //
// ./src/reports/outlet/byor/byor.select.column.controller.js